<div id="tab-one-b" class="" *ngIf=" validityView">
  <a (click)="onReturnToLicenses()" class="back u-mb40 toggle global-hand" data-id="tab-one-c">
    Vigencia de documentos
  </a>

  <div class="u-bt u-bt--grey">
    <div class="row">
      <div class="col-md-3 u-pt30 u-pb10">
        <h3 class="txt txt--section">
          {{licenseData.asset?.name}}
        </h3>
        <p class="txt txt--paragraph">
          Nº: {{licenseData.licenseNumber}}
        </p>
      </div>
      <div class="col-md-9 u-right u-pt30 u-pb20">
        <div class="innermenu">
          <ul>
            <li>
              <a routerLink="/license/renew">Renovar licencia</a>
            </li>
            <li>
              <a routerLink="/license/extend">Ampliar licencia</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <div class="u-bt u-bt--grey u-pt20">
    <div class="row">
      <div class="col-md-3">
        <h4 class="txt txt--paragraph u-mb10">
          <strong>
            Restricciones de conducción:
          </strong>
        </h4>
        <p class="txt txt--small txt--grey">
          {{licenseData.asset?.drivingRestriction}}
        </p>
      </div>
    </div>
  </div>

  <div *ngFor="let item of licenseData.equipments; let index = index;">
    <app-equipment-row [index]="index" [equipmentId]="item.equipmentId" [equipmentName]="item.equipmentName"
      [equipmentBrand]="item.equipmentBrand" [equipmentModel]="item.equipmentModel" [licenseTypes]="item.licenseTypes"
      [conductionZones]="item.conductionZones" [expiredAt]="item.expiredAt" [municipalLicenses]="item.municipalLicenses"
      [state]="item.equipmentStatus">
    </app-equipment-row>
  </div>
  <!-- <app-table-details-documents [id]="licenseData.id"></app-table-details-documents> -->
  <app-document-table
  *ngIf="licenseData.asset && licenseData.userRutDv && licenseData.requirementId"
  [documents]="documents"
  [shouldShowDocumentLinks]="true"
  [assetId]="licenseData.asset.id"
  [driverMdmid]="licenseData.userRutDv"
  [requirementId]="licenseData.requirementId"
  [driverIsEmployee]="driverIsEmployee"
  ></app-document-table>

</div>
